export default __webpack_public_path__ + "static/media/campground.6a5f7845.jpg";